import { render } from "./rebateList.vue?vue&type=template&id=28849692"
import script from "./rebateList.vue?vue&type=script&lang=js"
export * from "./rebateList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__